module.exports = __webpack_public_path__ + "static/media/rbahn-echtzeit~NUeRZzQE.816044e7.svg";